import { FC } from 'react';

import { Transaction } from 'dashboard/models/transaction';
import { TransactionStatus } from 'dashboard/models/transaction-status';
import { TransactionType } from 'dashboard/models/transaction-type';
import ResourceTransaction from 'dashboard/modules/ResourceTransaction';

interface RelatedTransactionsProps {
  transactions: Transaction[];
}

const RelatedTransactions: FC<RelatedTransactionsProps> = ({ transactions }) => (
  <>
    {transactions.map((transaction) => (
      <ResourceTransaction
        key={transaction.id}
        defaultAccordionOpen={false}
        transaction={transaction}
        transactionStatus={
          transaction.relationships['transaction-status'].data as TransactionStatus
        }
        transactionType={transaction.relationships['transaction-type'].data as TransactionType}
      />
    ))}
  </>
);

export default RelatedTransactions;
